import { useMemo } from 'react';
import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Accordion, Text } from '@frontend/design-system';
import { UserRole } from '../../utils/constants';
import { checkRbacAccess, formatString } from '../../utils/helpers';
import { IntegrationsMetadata } from '../../utils/typings';

interface PmsVersionsAccordionProps {
  pmsVersions?: string[];
  integrationsMetadata?: IntegrationsMetadata;
  userRole?: keyof typeof UserRole;
}

const PmsVersionsAccordion = ({ pmsVersions, integrationsMetadata, userRole }: PmsVersionsAccordionProps) => {
  const hasViewAccess = useMemo(
    () => checkRbacAccess(integrationsMetadata?.supportedPmsVersions, userRole).hasViewAccess,
    [integrationsMetadata, userRole]
  );

  return (
    <Accordion variant='main' showBoxShadow>
      <Accordion.Item value='pms-versions'>
        <Accordion.Header>
          <Text weight='bold'>PMS Versions</Text>
        </Accordion.Header>
        <Accordion.Body css={containerStyle}>
          {pmsVersions && pmsVersions.length > 0 && hasViewAccess ? (
            pmsVersions.map((chip) => <Text key={chip}>{formatString(chip)}</Text>)
          ) : (
            <Text>No PMS Versions available.</Text>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default PmsVersionsAccordion;

const containerStyle = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${theme.spacing(2)};
  align-items: start;

  @media (max-width: ${breakpoints.mobile.min}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${breakpoints.xsmall.max}px) {
    grid-template-columns: 1fr;
  }
`;
